var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChassisDetails = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.4 9.7V4.3h-3.5v2.3h-5.1V4.3H7.3v5.4h3.5V7.4H13v11h-2.2v-2.9H7.3v6.1h3.5v-2.4h5.1v2.4h3.5v-6.1h-3.5v2.9h-2.2v-11h2.2v2.4h3.5zm-2.7-4.6h1.9V9h-1.9zM10 9H8.1V5.1H10zm0 11.8H8.1v-4.5H10zm6.7-4.5h1.9v4.5h-1.9z"
})));
export default SvgChassisDetails;